export default __webpack_public_path__ + "static/media/custom-login.6c4b4ca3.png";